<div class="dialog-content-wrapper h-full" cslPerfectScrollbar>
  <mat-toolbar class="mat-accent m-0">
    <mat-toolbar-row class="flex justify-between items-center">
      <span class="title dialog-title" i18n>Просмотр модели</span>
      <button mat-button class="mat-icon-button" (click)="dialogRef.close(undefined)" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="p-0 pb-0 m-0 h-full">
    <div class="flex justify-between items-stretch content-wrapper h-full">
      <div class="flex-grow model-viewer-wrapper">
        <model-viewer
          [environmentImage]="'neutral'"
          class="w-full h-full"
          #viewer
          preload
          alt="A 3D model"
          [exposure]="exposure"
          camera-controls>
        </model-viewer>
      </div>

      <div class="basis-[420px] p-4 accordion-wrapper flex" [ngClass]="{ hidden: animations.length === 0 }">
        <mat-accordion multi="true" class="w-full">
          <mat-expansion-panel expanded="true" class="animation-list-panel">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="flex items-center gap-2">
                  <div class="flex items-center gap-2">
                    <div i18n>Анимация</div>
                  </div>
                  <button
                    (click)="$event.stopPropagation(); $event.preventDefault(); playAll()"
                    mat-stroked-button
                    i18n-matTooltip
                    matTooltip="Воспроизвести все"
                    *ngIf="animations.length > 0">
                    Воспроизвести все
                  </button>
                  <button
                    (click)="$event.stopPropagation(); $event.preventDefault(); stopAnimation()"
                    mat-stroked-button
                    i18n-matTooltip
                    matTooltip="Остановить анимацию"
                    *ngIf="animations.length > 0">
                    <mat-icon>stop</mat-icon>
                  </button>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div *ngFor="let anim of animations" class="flex items-center gap-1">
              <button
                mat-icon-button
                (click)="playAnimation(anim)"
                i18n-matTooltip
                matTooltip="Воспроизвести"
                *ngIf="anim !== activeAnimation">
                <mat-icon>play_arrow</mat-icon>
              </button>

              <button
                mat-icon-button
                (click)="pauseAnimation()"
                i18n-matTooltip
                matTooltip="Пауза"
                *ngIf="anim === activeAnimation">
                <mat-icon>pause</mat-icon>
              </button>

              <button mat-icon-button (click)="stopAnimation()" i18n-matTooltip matTooltip="Остановить анимацию">
                <mat-icon>stop</mat-icon>
              </button>

              <div>{{ anim }}</div>
            </div>
            <div *ngFor="let mat of materials">
              {{ mat.name }}
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  </div>
</div>
